// extracted by mini-css-extract-plugin
module.exports = {"root":"HomePage_root__nWOC1"};